"use client";
import { Menu, ChevronDown, X } from "lucide-react";
import { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import LOGO from "../../../assets/logo.png";
import LOGOWHITE from "../../../assets/logowhite.png";
import { useAppDispatch, useAppSelector } from "../../../_hooks/hooks";
import { getAllActiveBanner } from "@/screens/home/services/home.services";

const GalleryList = [
  { value: "Image Gallery", title: "IMAGE GALLERY", url: "/image-gallery/" },
  { value: "Video Gallery", title: "VIDEO GALLERY", url: "/video-gallery/" },
];
const PropertyList = [
  {
    name: "RAJASTHAN",
    slug: "",
    main: true,
  },
  // {
  //   PropertyName: "Kavish Holiday Hill Resort n Spa - Udaipur",
  //   PropertyURL: "/kavish-holiday-hill-resort-n-spa",
  //   main: false,
  // },
  {
    PropertyName: "Kavish The Haveli Resort - Kumbhalgarh",
    PropertyURL: "/kavish-the-haveli-resort",
    main: false,
  },
  {
    PropertyName: "Kavish Jawai Village Resort - Jawai",
    PropertyURL: "/kavish-jawai-village-resort",
    main: false,
  },
  {
    name: "GUJARAT",
    slug: "",
    main: true,
  },
  {
    PropertyName: "Kavish Gir Lion Resort - Sasan Gir",
    PropertyURL: "/kavish-gir-lion-resort",
    main: false,
  },
];

export function HeaderNew({ globalData }: { globalData?: any }) {
  const dispatch = useAppDispatch();
  // const PropertyList = globalData?.properties || [];
  const PackageList = useAppSelector((state) => state.package.PackageList);
  const [scrolled, setScrolled] = useState(false);
  const [isResortsOpen, setIsResortsOpen] = useState(false);
  const [isPackagesOpen, setIsPackagesOpen] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    dispatch(getAllActiveBanner());
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dispatch]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isMobileMenuOpen
          ? "bg-white"
          : scrolled
            ? "bg-white/98 backdrop-blur-lg shadow-lg border-b border-gray-100"
            : "bg-gradient-to-b from-black/40 to-transparent"
      }`}
    >
      <div
        className="container mx-auto px-4 sm:px-6 lg:px-8"
        style={
          isMobileMenuOpen
            ? {
                maxHeight: "100vh",
                overflow: "auto",
                scrollbarWidth: "none",
              }
            : {}
        }
      >
        {/* Desktop Menu */}
        <div className="flex items-center justify-between h-30">
          {/* Desktop Left Menu */}
          <nav className="hidden lg:flex items-center space-x-8 flex-1">
            <div
              className="relative group"
              onMouseEnter={() => setIsResortsOpen(true)}
              onMouseLeave={() => setIsResortsOpen(false)}
            >
              <button
                className={`flex items-center gap-2 transition-colors text-base tracking-wide font-semibold ${
                  scrolled
                    ? "text-gray-700 hover:text-[#B42025]"
                    : "text-white hover:text-[#C9A962]"
                }`}
              >
                KAVISH RETREATS
                <ChevronDown
                  className={`h-4 w-4 transition-transform ${isResortsOpen ? "rotate-180" : ""}`}
                />
              </button>
              <div
                className={`absolute top-full left-0 mt-2 w-100 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden transition-all duration-300 ${
                  isResortsOpen
                    ? "opacity-100 visible translate-y-0"
                    : "opacity-0 invisible -translate-y-2"
                }`}
              >
                {PropertyList?.map((resort: any, index: number) =>
                  resort.main ? (
                    <div
                      key={index}
                      className="block px-6 py-4 bg-[#F9F7F4] transition-colors border-b border-gray-100 last:border-0 group/item font-semibold"
                    >
                      <span className="text-[#B42025]">{resort.name}</span>
                    </div>
                  ) : (
                    <Link
                      key={index}
                      href={`${resort?.PropertyURL || ""}/`}
                      className="block px-6 py-4  transition-colors border-b border-gray-100 last:border-0 group/item"
                    >
                      <span className="text-gray-700 group-hover/item:text-[#B42025] transition-colors">
                        {resort?.PropertyName}
                      </span>
                    </Link>
                  ),
                )}
              </div>
            </div>

            <div
              className="relative group"
              onMouseEnter={() => setIsPackagesOpen(true)}
              onMouseLeave={() => setIsPackagesOpen(false)}
            >
              <button
                className={`flex items-center gap-2 transition-colors text-base tracking-wide font-semibold ${
                  scrolled
                    ? "text-gray-700 hover:text-[#B42025]"
                    : "text-white hover:text-[#C9A962]"
                }`}
              >
                SPECIAL OFFER
                <ChevronDown
                  className={`h-4 w-4 transition-transform ${isPackagesOpen ? "rotate-180" : ""}`}
                />
              </button>
              <div
                className={`absolute top-full left-0 mt-2 w-80 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden transition-all duration-300 ${
                  isPackagesOpen
                    ? "opacity-100 visible translate-y-0"
                    : "opacity-0 invisible -translate-y-2"
                }`}
              >
                {PackageList.map((resort: any, index: number) => (
                  <Link
                    key={index}
                    href={`/packages/${resort?.PackageURL || ""}/`}
                    className="block px-6 py-4 hover:bg-[#F9F7F4] transition-colors border-b border-gray-100 last:border-0 group/item"
                  >
                    <span className="text-gray-700 group-hover/item:text-[#B42025] transition-colors">
                      {resort?.PackageTitle}
                    </span>
                  </Link>
                ))}
              </div>
            </div>

            <Link
              href="/weddings-events/"
              className={`transition-colors text-base tracking-wide font-semibold ${
                scrolled
                  ? "text-gray-700 hover:text-[#B42025]"
                  : "text-white hover:text-[#C9A962]"
              }`}
            >
              WEDDINGS
            </Link>
          </nav>

          {/* Center Logo */}
          <div className="flex items-center justify-center flex-shrink-0 px-4 my-2">
            <Link
              href="/"
              onClick={() => {
                setIsMobileMenuOpen(false);
              }}
            >
              {/* <Image
                src={LOGOWHITE}
                alt="Kavish Hotels & Resorts"
                width={160}
                height={80}
                sizes="160px"
                className={`h-20 w-auto transition-all duration-300 ${scrolled || isMobileMenuOpen ? "brightness-0" : "brightness-100"
                  }`}
                priority
              /> */}
              <img
                src={
                  isMobileMenuOpen
                    ? LOGO.src
                    : scrolled
                      ? LOGO.src
                      : LOGOWHITE.src
                }
                alt="Kavish Hotels & Resorts"
                width={180}
                height={180}
                // sizes="(max-width: 768px) 80px, 96px"
                className="h-30 w-auto transition-all duration-300"
                // priority
                // quality={40}
              />
            </Link>
          </div>

          {/* Desktop Right Menu */}
          <nav className="hidden lg:flex items-center justify-end space-x-6 flex-1">
            <Link
              href="/about-kavish-hotels-and-resorts/"
              className={`transition-colors text-base tracking-wide font-semibold ${
                scrolled
                  ? "text-gray-700 hover:text-[#B42025]"
                  : "text-white hover:text-[#C9A962]"
              }`}
            >
              ABOUT
            </Link>
            <Link
              href="/blogs/"
              className={`transition-colors text-base tracking-wide font-semibold ${
                scrolled
                  ? "text-gray-700 hover:text-[#B42025]"
                  : "text-white hover:text-[#C9A962]"
              }`}
            >
              BLOGS
            </Link>
            <div
              className="relative group"
              onMouseEnter={() => setIsGalleryOpen(true)}
              onMouseLeave={() => setIsGalleryOpen(false)}
            >
              <button
                className={`flex items-center gap-2 transition-colors text-base tracking-wide font-semibold ${
                  scrolled
                    ? "text-gray-700 hover:text-[#B42025]"
                    : "text-white hover:text-[#C9A962]"
                }`}
              >
                GALLERY
                <ChevronDown
                  className={`h-4 w-4 transition-transform ${isGalleryOpen ? "rotate-180" : ""}`}
                />
              </button>
              <div
                className={`absolute top-full right-0 mt-2 w-48 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden transition-all duration-300 ${
                  isGalleryOpen
                    ? "opacity-100 visible translate-y-0"
                    : "opacity-0 invisible -translate-y-2"
                }`}
              >
                {GalleryList.map((gallery: any, index: number) => (
                  <Link
                    key={index}
                    href={`${gallery?.url || "#"}`}
                    className="block px-6 py-4 hover:bg-[#F9F7F4] transition-colors border-b border-gray-100 last:border-0 group/item"
                  >
                    <span className="text-sm text-gray-700 group-hover/item:text-[#B42025] transition-colors">
                      {gallery?.title}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
            <Link
              href="/kavish-hotels-and-resorts-contact-details/"
              className={`transition-colors text-base tracking-wide font-semibold ${
                scrolled
                  ? "text-gray-700 hover:text-[#B42025]"
                  : "text-white hover:text-[#C9A962]"
              }`}
            >
              CONTACT
            </Link>
            {/* <div className="flex items-center gap-4">
              <Link href="/kavish-hotels-and-resorts-contact-details/">
                <Button
                  variant="ghost"
                  size="sm"
                  className={`${
                    scrolled
                      ? "text-gray-700 hover:text-[#B42025] hover:bg-[#F9F7F4]"
                      : "text-white hover:text-[#C9A962] hover:bg-white/10"
                  }`}
                >
                  <Phone className="h-4 w-4 mr-2" />
                  Contact
                </Button>
              </Link>
              <Button className="bg-[#B42025] hover:bg-[#8F1A1E] text-white shadow-lg hover:shadow-xl transition-all duration-300">
                Book Now
              </Button>
            </div> */}
          </nav>

          {isMobileMenuOpen ? (
            <button
              aria-label="Close Mobile Menu"
              className={`lg:hidden text-black`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <X className="h-7 w-7" />
            </button>
          ) : (
            <button
              aria-label="Open Mobile Menu"
              className={`lg:hidden ${scrolled ? "text-gray-700" : "text-white"}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <Menu className="h-7 w-7" />
            </button>
          )}
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-6 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <div>
                <button
                  onClick={() => setIsResortsOpen(!isResortsOpen)}
                  className="flex items-center justify-between w-full text-gray-700 hover:text-[#B42025] py-2 font-semibold"
                >
                  KAVISH RETREATS
                  <ChevronDown
                    className={`h-4 w-4 transition-transform ${isResortsOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {isResortsOpen && (
                  <div className="mt-2 space-y-2">
                    {PropertyList?.map((resort: any, index: number) =>
                      resort.main ? (
                        <div
                          key={index}
                          className="pl-2 block py-2 text-sm bg-[#F9F7F4] font-semibold"
                        >
                          <span className="text-[#B42025]">{resort.name}</span>
                        </div>
                      ) : (
                        <Link
                          key={index}
                          href={`${resort?.PropertyURL || ""}/`}
                          onClick={() => {
                            setIsMobileMenuOpen(false);
                          }}
                          className="pl-4 block py-2 text-sm text-gray-600 hover:text-[#B42025]"
                        >
                          {resort?.PropertyName}
                        </Link>
                      ),
                    )}
                  </div>
                )}
              </div>
              <div>
                <button
                  onClick={() => setIsPackagesOpen(!isPackagesOpen)}
                  className="flex items-center justify-between w-full text-gray-700 hover:text-[#B42025] py-2 font-semibold"
                >
                  SPECIAL OFFER
                  <ChevronDown
                    className={`h-4 w-4 transition-transform ${isPackagesOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {isPackagesOpen && (
                  <div className="pl-4 mt-2 space-y-2">
                    {PackageList.map((resort: any, index: number) => (
                      <Link
                        key={index}
                        href={`/packages/${resort?.PackageURL || ""}/`}
                        onClick={() => {
                          setIsMobileMenuOpen(false);
                        }}
                        className="block py-2 text-sm text-gray-600 hover:text-[#B42025]"
                      >
                        {resort?.PackageTitle}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
              <Link
                href="/weddings-events/"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-[#B42025] py-2 font-semibold"
              >
                WEDDINGS
              </Link>
              <Link
                href="/about-kavish-hotels-and-resorts/"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-[#B42025] py-2 font-semibold"
              >
                ABOUT
              </Link>
              <Link
                href="/career/"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-[#B42025] py-2 font-semibold"
              >
                CAREER
              </Link>
              <div>
                <button
                  onClick={() => setIsGalleryOpen(!isGalleryOpen)}
                  className="flex items-center justify-between w-full text-gray-700 hover:text-[#B42025] py-2 font-semibold"
                >
                  GALLERY
                  <ChevronDown
                    className={`h-4 w-4 transition-transform ${isGalleryOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {isGalleryOpen && (
                  <div className="pl-4 mt-2 space-y-2">
                    {GalleryList.map((gallery: any, index: number) => (
                      <Link
                        key={index}
                        href={`${gallery?.url || "#"}`}
                        onClick={() => {
                          setIsMobileMenuOpen(false);
                        }}
                        className="block py-2 text-sm text-gray-600 hover:text-[#B42025]"
                      >
                        {gallery?.title}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
              <Link
                href="/faq/"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-[#B42025] py-2 font-semibold"
              >
                FAQS
              </Link>
              <Link
                href="/blogs/"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-[#B42025] py-2 font-semibold"
              >
                BLOGS
              </Link>
              <Link
                href="/kavish-hotels-and-resorts-contact-details/"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-[#B42025] py-2 font-semibold"
              >
                CONTACT
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
